export const ShowStickyCTAButton = {
  mounted() {
    this.maybeShowStickyButton();
  },

  updated() {
    this.maybeShowStickyButton();
  },

  maybeShowStickyButton() {
    const stickyButtonContainer = this.el;
    const staticCTAButton = document.querySelector('[data-behavior=addToCart]');

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver(
      (elements) => {
        elements.map((element) =>
          stickyButtonContainer.classList.toggle('translate-y-20', element.isIntersecting)
        );
      },
      {
        threshold: 1.0,
        rootMargin: '-7px 0px 1024px 0px'
      }
    );

    this.observer.observe(staticCTAButton);
  }
};
